import { render, staticRenderFns } from "./DeliveryAreaFeeModifyForm.vue?vue&type=template&id=789db8e3&scoped=true&"
import script from "./DeliveryAreaFeeModifyForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAreaFeeModifyForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryAreaFeeModifyForm.vue?vue&type=style&index=0&id=789db8e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789db8e3",
  null
  
)

export default component.exports